import DOMPurify from 'dompurify';

import { getAppConfig } from '../utilities';
import oktaAuth from './oktaAuth';

const onAuthRequired = () => {
  const { path = '' } = getAppConfig('server');

  // save the current url so the user is redirect back after a successful login
  oktaAuth.setOriginalUri(`${window.location.pathname}${window.location.search}`);

  const redirect = `${path}/login`;
  window.location.href = DOMPurify.sanitize(redirect);
};

export default onAuthRequired;
